import { defineMessages } from 'react-intl'

const scope = `procurify.platform.integrations.features.sync-unlinked-slack-users`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'Users synced successfully.',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  defaultErrorMessage: {
    id: `${scope}.defaultErrorMessage`,
    defaultMessage: 'Failed to sync users. Please try again.',
  },
  reconnectErrorMessage: {
    id: `${scope}.reconnectErrorMessage`,
    defaultMessage:
      "Slack connection has expired. Please reconnect via the 'Add to Slack' button.",
  },
})
